import { useRef } from 'react'

import { emptyFunction } from 'utils'

import * as Styled from './styled'
import { TInputTypes } from './interfaces'
import { InputActionButtons } from './action-buttons'

export interface IInputProps {
  type?: TInputTypes
  placeholder?: string
  onChange: (value: string) => void
  onClearValue?: () => void
  value?: string
  defaultValue?: string
  errorOutLine?: boolean
  warningOutLine?: boolean
  name?: string
  onBlur?: () => void
  className?: string
  handleSearch?: (value: string) => void
  isStaticView?: boolean //todoA for clickable input without debounce search onChange
  setInputBlockElement?: (ref: HTMLInputElement) => void
}

const Input: React.FC<IInputProps> = ({
  type = 'text',
  placeholder,
  onChange,
  onClearValue,
  value,
  defaultValue,
  name,
  errorOutLine,
  warningOutLine,
  onBlur = emptyFunction,
  className,
  handleSearch,
  isStaticView = false,
  setInputBlockElement
}) => {
  const inputRef = useRef<HTMLInputElement | null>(null)
  const isSearchType = type === 'search'

  const onInputBlur = () => {
    onBlur()
  }

  const handleRemoveClick = () => {
    if (onClearValue) {
      onClearValue()
    } else if (inputRef.current) {
      inputRef.current.value = ''
    }
  }

  const onHandleSearch = () => {
    if (handleSearch && inputRef.current) {
      handleSearch(inputRef.current.value)
    }
    return emptyFunction
  }

  const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length === 0) {
      onClearValue && onClearValue()
    }
    onChange(e.target.value)
  }

  return (
    <Styled.InputBlock className={className} ref={setInputBlockElement}>
      <Styled.Input
        type={type}
        placeholder={placeholder}
        onChange={handleOnChange}
        value={value}
        defaultValue={defaultValue}
        $isError={errorOutLine}
        $isWarning={warningOutLine}
        $isSearchType={isSearchType}
        ref={inputRef}
        name={name}
        onBlur={onInputBlur}
        $isStaticView={isStaticView}
      />

      {isSearchType && (
        <InputActionButtons
          value={value}
          handleRemoveClick={handleRemoveClick}
          isStaticView={isStaticView}
          handleSearch={onHandleSearch}
        />
      )}
    </Styled.InputBlock>
  )
}

export default Input
